import {
  AfterViewInit,
  Component,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';

import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/distinctUntilChanged';

import {
  ListStateDispatcher,
  ListToolbarItemModel
} from '../list/state';

import { SkyListSecondaryActionsService } from './list-secondary-actions.service';
import { SkyListSecondaryAction } from './list-secondary-action';


export class SkyListSecondaryActionsComponent implements OnInit, AfterViewInit, OnDestroy {
  public dropdownHidden = false;
  public actions: any[] = [];

  
  private secondaryActionsTemplate: TemplateRef<any>;

  private ngUnsubscribe = new Subject();

  constructor(
    private changeDetector: ChangeDetectorRef,
    private dispatcher: ListStateDispatcher,
    private actionService: SkyListSecondaryActionsService
  ) { }

  public ngOnInit() {
    this.actionService.actionsStream
      .takeUntil(this.ngUnsubscribe)
      .distinctUntilChanged()
      .subscribe((actions: SkyListSecondaryAction[]) => {
        const hasSecondaryActions = (actions.length > 0);
        this.dropdownHidden = !hasSecondaryActions;
        this.actions = actions;
        this.changeDetector.detectChanges();
      });
  }

  public ngAfterViewInit() {
    const secondaryActionItem = new ListToolbarItemModel({
      id: 'secondary-actions',
      template: this.secondaryActionsTemplate,
      location: 'right'
    });

    this.dispatcher.toolbarAddItems([secondaryActionItem], -1);
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-list-secondary-actions',
  template: `<ng-template #secondaryActions>
  <div
    class="sky-list-secondary-actions"
    [ngClass]="{ 'sky-list-secondary-actions-hidden': dropdownHidden }">
    <sky-dropdown
      buttonType="context-menu"
      [title]="'list_show_secondary_actions' | skyResources">
      <sky-dropdown-menu>
        <sky-dropdown-item
          *ngFor="let action of actions">
          <ng-container
            *ngTemplateOutlet="action.template">
          </ng-container>
        </sky-dropdown-item>
      </sky-dropdown-menu>
    </sky-dropdown>
  </div>
  <ng-content>
  </ng-content>
</ng-template>
`,
  styles: [`.sky-list-secondary-actions ::ng-deep .sky-dropdown-button-type-context-menu {
  padding: 6px 12px;
}

.sky-list-secondary-actions ::ng-deep .sky-dropdown-button-type-context-menu .fa-ellipsis-h {
  /* add styles for fa-lg */
  font-size: 1.33333em;
  line-height: .75em;
  vertical-align: -15%;
}

.sky-list-secondary-actions-hidden {
  display: none;
}
`],
  providers: [
    SkyListSecondaryActionsService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ChangeDetectorRef, },
{type: ListStateDispatcher, },
{type: SkyListSecondaryActionsService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'secondaryActionsTemplate': [{ type: ViewChild, args: ['secondaryActions', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
